import React                    from 'react';

const WebIcon = () => {
    return (
        <div className="section-wrapper-header-web">
        </div>
    )
}

export default WebIcon;